import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import DOMPurify from "dompurify";

/**
 * Removes script-capable markup (script tags, event handlers, javascript: URLs, ...) from
 * stored rich text. Unlike Angular's built-in sanitizer it keeps inline styles, so
 * editor formatting (alignment, colours, tables) in reports survives.
 */
export function sanitizeHtml(value: unknown): string {
  if (value === null || value === undefined) {
    return "";
  }

  return DOMPurify.sanitize(String(value));
}

/** Use instead of `bypassSecurityTrustHtml` for any HTML that came from users or the API. */
export function trustSanitizedHtml(sanitizer: DomSanitizer, value: unknown): SafeHtml {
  return sanitizer.bypassSecurityTrustHtml(sanitizeHtml(value));
}
